
export enum GetAuctionStatusCountsResponseDtoStatesItem {
  Pending= 'Pending',
  Running= 'Running',
  Expired= 'Expired',

}